import { FC, PropsWithChildren } from 'react';
import Link from 'next/link';
import styles from './ScrollCardsList.module.scss';

interface IScrollCardsListProps {
  extraClassName?: string;
  moreBtnUrl?: string;
  moreBtnName?: string;
}

const ScrollCardsList: FC<PropsWithChildren<IScrollCardsListProps>> = ({ children, extraClassName, moreBtnUrl, moreBtnName }) => {
  const getListClassNames = () => (extraClassName ? `${styles.scrollXWrapper} ${styles[`${extraClassName}`]}` : `${styles.scrollXWrapper}`);

  return (
    <div className={getListClassNames()}>
      <div className={styles.scrollCards} data-scrollbar="styles">
        <div className={styles.scrollCards__wrap}>{children}</div>
      </div>
      {moreBtnUrl && moreBtnName && (
        <Link className={styles.scrollCards__btn} prefetch={false} href={moreBtnUrl}>
          {moreBtnName}
        </Link>
      )}
    </div>
  );
};

export default ScrollCardsList;
